<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ct"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfm"><a class="xref" href="#/chihoeckner0007#fore">Foreword: The Same Old Tune, but with a Different Meaning</a></p>
<p class="tocau">Tom Gunning</p>
<p class="toc"><a class="xref" href="#/chihoeckner0008#intro">Introduction</a></p>
<p class="tocpt"><a class="xref" href="#/chihoeckner0009#pt01">1   Storage</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0010#ch01">1   Record Recollections</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0011#ch02">2   Tertiary Rememories</a></p>
<p class="tocpt"><a class="xref" href="#/chihoeckner0012#pt02">2   Retrieval</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0013#ch03">3   Double Projections</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0014#ch04">4   Auratic Replays</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0015#ch05">5   Panoramic Flashbacks</a></p>
<p class="tocpt"><a class="xref" href="#/chihoeckner0016#pt03">3   Affect</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0017#ch06">6   Freudian Fixations</a></p>
<p class="toc"><a class="xref" href="#/chihoeckner0018#ch07">7   Affective Attachments</a></p>
<p class="tocbmf"><a class="xref" href="#/chihoeckner0019#coda">Coda</a></p>
<p class="tocbmf"><a class="xref" href="#/chihoeckner0020#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chihoeckner0021#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chihoeckner0022#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hoeckner-0006.vue?4276d518